import { render, staticRenderFns } from "./CultureAssetDisposeInfo.vue?vue&type=template&id=1e1a82dc&scoped=true&"
import script from "./CultureAssetDisposeInfo.vue?vue&type=script&lang=js&"
export * from "./CultureAssetDisposeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a82dc",
  null
  
)

export default component.exports